module.exports = [{"fromPath":"/get-to-know/","isPermanent":true,"redirectInBrowser":true,"toPath":"/get-to-know"},{"fromPath":"/product-info/","isPermanent":true,"redirectInBrowser":true,"toPath":"/product-info"},{"fromPath":"/affiliations/","isPermanent":true,"redirectInBrowser":true,"toPath":"/affiliations"},{"fromPath":"/contact.html","isPermanent":true,"redirectInBrowser":true,"toPath":"/connect"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/redirects.json
// module id = 557
// module chunks = 231608221292675